import React from "react"

import Alert, {AlertTypes} from "@irati/ui/src/Alert"

export default () => <Alert nonDismissable type={AlertTypes.warning} title="perks.components.productForms.maxProductsReached.text" />
